.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.empty {
	margin: 0;
	color: var(--ink-muted);
	font-size: 0.875rem;
}

.list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: var(--space-1);
	max-height: 50vh;
	overflow-y: auto;
}

.item {
	display: flex;
	align-items: center;
	gap: var(--space-3);
	width: 100%;
	border: none;
	background: transparent;
	padding: var(--space-2) var(--space-3);
	border-radius: var(--radius-sm);
	font: inherit;
	color: inherit;
	text-align: left;
	cursor: pointer;
}

.item:hover {
	background: var(--surface-input);
}

.selected {
	background: var(--surface-input);
}

.avatar {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	flex: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 0.8125rem;
	font-weight: 600;
}

.name {
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.check {
	flex: none;
	color: var(--accent-sage);
}

.actions {
	display: flex;
	justify-content: flex-end;
}

.done {
	background: var(--accent-sage);
	color: #fff;
	border: none;
	border-radius: var(--radius-sm);
	padding: var(--space-2) var(--space-4);
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}
